<template>
  <div>
    <v-dialog v-model="openModal"  >
      <v-card >
        <v-card-text>
          <v-row>
            <v-col cols="12 text-center" v-show="!loadIframe">
              <v-progress-circular
                indeterminate
                color="primary"
                :size="100"
                :width="7"
              ></v-progress-circular>
            </v-col>
          </v-row>
          <v-row v-show="loadIframe">
            <v-col cols="12">
              <iframe
                @load="loadIframe = true"
                :src="url"
                frameborder="0"
                style="min-width: 100%; width: 100%; height: 535px"
              ></iframe>
              <v-btn
                class="mr-2 text-center"
                color="error"
                outlined=""
                @click="openModal = false;loadIframe = false;url = ''"
              >
                <v-icon left="">mdi-backspace</v-icon> Cerrar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      openModal: false,
      idventa_detalle: "",
      url: "",
      loadIframe: false,
    };
  },
  props: {
    objModalImpresion: {
      type: Object,
    },
  },
  watch: {
    openModal:function(newValue, old){
      if(!newValue){
        this.idventa_detalle = "";
        this.url = "";
        this.loadIframe = false;
      }
    },
    objModalImpresion(val) {
      this.loadIframe = false;
      this.openModal = val.openModal;
      this.idventa_detalle = val.idventa_detalle;
      this.url = this.apiUrl('api/panel/ventas/v2/impresion-receta?idventa_detalle=' + this.idventa_detalle);
    },
  },
};
</script>
